<div class="flex">
  <app-user-affiliate-share-card
    [data]="affiliate"
  ></app-user-affiliate-share-card>

  <app-user-affiliate-available-commission-card
    [data]="affiliate"
  ></app-user-affiliate-available-commission-card>

  <app-user-affiliate-frozen-commission-card
    [data]="affiliate"
  ></app-user-affiliate-frozen-commission-card>

  <app-user-affiliate-total-commission-card
    [data]="affiliate"
  ></app-user-affiliate-total-commission-card>
</div>

<div class="flex">
  <div *ngIf="affiliate.is_partner">
    <app-user-affiliate-create-coupon
      style="margin-bottom: 20px"
    ></app-user-affiliate-create-coupon>
    <app-user-affiliate-order-pie-card></app-user-affiliate-order-pie-card>
  </div>
  <ng-container *ngIf="!affiliate.is_partner">
    <app-user-affiliate-create-coupon></app-user-affiliate-create-coupon>
    <app-user-affiliate-info-panel></app-user-affiliate-info-panel>
    <app-user-affiliate-order-pie-card></app-user-affiliate-order-pie-card>
  </ng-container>

  <app-user-affiliate-order-line-card
    [height]="affiliate.is_partner ? '505px' : '327px'"
  ></app-user-affiliate-order-line-card>
</div>

<app-user-affiliate-order-list-card></app-user-affiliate-order-list-card>
